export default __webpack_public_path__ + "static/media/Auftragskorb.575fb1fc.jpg";